import React from 'react';
import {UserSelector} from 'components/pure/utils/form/UserSelector';
import pick from 'lodash/pick';
import {validate} from 'records/CoachingPlan';
import FieldContainer from 'components/pure/utils/form/FieldContainer';

export default class CoachStep extends React.PureComponent {
  static title = 'Coach';

  static validate(plan) {
    return pick(validate(plan), ['coach']);
  }

  render() {
    const {model: coachingPlan, onChange, showErrors, frozen} = this.props;
    const errors = CoachStep.validate(coachingPlan);

    const possibleCoaches = this.props.users
      .filter(u => u.canCoach())
      .filter(u => u.id !== coachingPlan.recipient.id);

    return this.props.userListError ? (
      <p>There was an error loading</p>
    ) : (
      <div className="coaching-step">
        <p>Who will be giving the coaching or teaching the lesson?</p>
        <FieldContainer labelType="div" error={showErrors && errors.coach ? errors.coach.id : null}>
          <UserSelector
            disabled={frozen}
            value={coachingPlan.coach.id}
            users={possibleCoaches}
            sessionUser={this.props.sessionUser}
            onChange={userId =>
              onChange(
                coachingPlan
                  .setIn(['coach', 'id'], userId)
                  .setIn(['coach', 'info'], possibleCoaches.get(userId))
              )
            }
          />
        </FieldContainer>
      </div>
    );
  }
}
